import { Modal } from "src/shared/components/layout/modal/Modal"
import HeaderIcon from "src/shared/components/data-display/header-icon/HeaderIcon"
import { Button } from "src/shared/components/forms"
import "./Confirmacion.css"
import { useSelector } from "react-redux"
import { RootState } from "src/store/store"
import { RoleNames } from "src/shared/hooks/useAuth"
import { useProfile } from "src/shared/hooks/useProfile"
import { useFetch } from "src/shared/hooks/useFetch"
import { useNavigate } from "react-router-dom"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { useOnLogout } from "src/shared/components/navigation/header/Header.helpers"
import {
    Corte,
    useCerrar_CorteMutation,
    useGetConfiguracionesPropinaQuery,
    useGetTurnosQuery,
    usePagarPropinasVentasMutation,
} from "src/gql/schema"
import { useState } from "react"
import { CrearCorteRes } from "src/pages/Cortes/interfaces/CrearCorteRes"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import { useTurnoActual } from "src/pages/home/room-detail/hooks/turnos"
import IconBorder from "src/shared/components/data-display/IconBorder/IconBorder"
import Icon from "src/shared/icons"
import corteDiaOpener from "src/shared/openers/corteDiaOpener"
import { useDate } from "src/shared/hooks/useDate"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import { handleRecepcionista } from "./helpers/handleRecepcionista"
import { handleAdminCerrarTurno } from "./helpers/handleAdminCerrarTurno"
import { handleAdminSinCerrarTurno } from "./helpers/handleAdminSinCerrarTurno"
import { createCerrarCorte } from "./helpers/cerrarCorte"
import { useCheckNocturnoEnd } from "./hooks/useCheckNocturnoEnd"
import { useCambiarTurno } from "./hooks/useCambiarTurno"
import { useLogoutOnStorageTrigger } from "./hooks/useLogoutOnStorageTrigger"
import { useEfectivo } from "src/pages/Cortes/Sections/ResumenTurno/hooks/useEfectivo"

const Confirmacion = ({
    openImpresion,
    setOpenImpresion,
    isUltimoCorte,
    corteSelected,
    numero_total_movimientos,
    suma_total_montos,
    fechaCorte,
    nombreTurnoCorte,
    corte_id = "",
}: {
    openImpresion: boolean
    setOpenImpresion: React.Dispatch<React.SetStateAction<boolean>>
    isUltimoCorte?: boolean
    corteSelected?: Corte
    numero_total_movimientos?: number
    suma_total_montos?: number
    fechaCorte?: Date
    nombreTurnoCorte?: string
    corte_id?: string
}) => {
    const { UTCStringToLocalDate } = useDate()
    const { onLogout } = useOnLogout()

    const navigate = useNavigate()
    const { hotel_id, usuario_id, turno_hotel_id, rolName, myProfile } = useProfile()
    const { efectivo_ingresado } = useSelector((state: RootState) => state.cortes)
    const [success, setSuccess] = useState<boolean>(false)
    const [successData, setSuccessData] = useState<any>({})
    const turnoActual = useTurnoActual()
    const { formatCustomDate, nowHotel } = useFormatDate()

    const { showSnackbar } = useSnackbar()
    const { checkNocturnoEnd } = useCheckNocturnoEnd()
    const { onClearEfectivo } = useEfectivo()

    const variables = { hotel_id, efectivo_ingresado, usuario_id, turno_id: turno_hotel_id }

    const { refetch: crearCorte } = useFetch<CrearCorteRes>("/cortes/crear_corte", {
        variables: { ...variables },
        startFetch: false,
    })

    const { data: turnos } = useGetTurnosQuery({
        variables: {
            hotel_id,
        },
    })

    const { cambiarTurno, pathSuccess } = useCambiarTurno({
        turnos: turnos?.turnos,
        turnoActual,
        setSuccess,
    })

    const onSuccessNewCorte = ({ corte_id }: { folio: string; corte_id: string }) => {
        setisCerrarCorteLoading(false)
        corteDiaOpener({
            stateNuevoCorteTurno: {
                corte_id,
            },
        })

        /*if (withLogout) {
            window.open(`/pdf/resumen-corte/${corte_id}/${WITH_LOGOUT}`, "_blank")
            return
        }
        navigate("/u")
        */
    }

    useLogoutOnStorageTrigger(onLogout)

    const [isCerrarCorteLoading, setisCerrarCorteLoading] = useState(false)
    const [disableButtons, setdisableButtons] = useState(false)

    const [cerrarCorteMutate] = useCerrar_CorteMutation()
    const [pagarPropinasVentas] = usePagarPropinasVentasMutation()

    const { data: fetchConfig } = useGetConfiguracionesPropinaQuery({ variables: { hotel_id } })

    const cerrarCorte = createCerrarCorte({
        cerrarCorteMutate,
        usuario_id,
        efectivo_ingresado,
        hotel_id,
        showSnackbar,
        navigate,
        setisCerrarCorteLoading,
        setOpenImpresion,
    })

    const onSubmit = async ({ withLogout }: { withLogout: boolean }) => {
        if (isCerrarCorteLoading) {
            return
        }
        setisCerrarCorteLoading(true)
        setdisableButtons(true)

        // El monto ya viaja en `variables` y en el closure de `cerrarCorte`, capturados en el
        // render previo al click: limpiarlo aquí no afecta a este envío y evita que el monto
        // de este corte se arrastre al siguiente.
        onClearEfectivo()

        // Al crear un corte, independiente del perfil, se ejecuta la siguiente mutación para crear el reporte de propinas.
        const config = fetchConfig?.configuraciones_propina?.[0]?.["paga_propina_en_turno"] || false
        if (!corte_id && config) {
            const pago = await pagarPropinasVentas({
                variables: {
                    payPropinasVentasInput: {
                        hotel_id,
                    },
                },
            })

            //Se agrega console para saber si esto falla, tenia un return y por eso no continuaba con el cierre del corte
            if (!pago.data?.pagar_propinas_ventas)
                console.log("Hubo un error al pagar propinas ventas")
        }

        // Si es RECEPCIONISTA se sabe que en esta pantalla siempre va a crear cortes
        if (rolName === RoleNames.recepcionista) {
            handleRecepcionista({
                withLogout,
                variables,
                crearCorte,
                cambiarTurno,
                setSuccessData,
                setSuccess,
                onSuccessNewCorte,
                showSnackbar,
                setOpenImpresion,
                setisCerrarCorteLoading,
                setdisableButtons,
            })
            return
        }

        // Si es ADMIN, SUPERADMIN O GERENTE, al crear el corte se cierra automáticamente
        const isRolConCierreAutomatico =
            rolName === RoleNames.superadmin || rolName === RoleNames.admin || rolName === RoleNames.gerente

        if (withLogout) {
            handleAdminCerrarTurno({
                isUltimoCorte,
                corteSelected,
                variables,
                isRolConCierreAutomatico,
                crearCorte,
                cerrarCorte,
                cambiarTurno,
                setSuccessData,
                onSuccessNewCorte,
                showSnackbar,
                setOpenImpresion,
                setisCerrarCorteLoading,
                setdisableButtons,
            })
            return
        }

        handleAdminSinCerrarTurno({
            isUltimoCorte,
            corteSelected,
            variables,
            isRolConCierreAutomatico,
            crearCorte,
            cerrarCorte,
            setSuccessData,
            setSuccess,
            onSuccessNewCorte,
            showSnackbar,
            setOpenImpresion,
            setisCerrarCorteLoading,
            setdisableButtons,
        })
    }


    const handleConfirm = (): void => {
        if (rolName === RoleNames.recepcionista) {
            onLogout()
        } else {
            navigate(pathSuccess)
        }
    }

    return (
        <>
            <Modal
                isOpen={openImpresion || (openImpresion && !isCerrarCorteLoading)}
                onClose={() => setOpenImpresion(false)}
                width={600}
                withCloseButton
                isCancelableOnClickOutside={false}
                className="modal-cortes-confirmacion"
            >
                <HeaderIcon
                    title={`¿Hacer corte ${nombreTurnoCorte?.toLowerCase() || ""} del ${formatCustomDate(
                        isUltimoCorte ? nowHotel : fechaCorte || nowHotel,
                        "DD/MMM/YY"
                    )}?`}
                    icon="DollarSquare"
                    className="modal-confirmacion__header-icon"
                />
                <p className="modal-confirmacion-subtitle">
                    Antes de hacer corte verifica que la cantidad recibida y las transacciones sean correctas. Cualquier
                    retiro de efectivo pendiente se añade al total de efectivo de este mismo corte.
                </p>
                {rolName === RoleNames.recepcionista ? (
                    <div className="modal-confirmacion-buttons-container">
                        <Button
                            disabled={disableButtons}
                            text="Hacer corte y cerrar sesión"
                            className="modal-confirmacion-button"
                            onClick={() => {
                                onSubmit({ withLogout: true })
                            }}
                        />
                    </div>
                ) : (
                    <div className="modal-confirmacion-buttons-container">
                        <Button
                            disabled={disableButtons}
                            theme="secondary"
                            text="Hacer corte"
                            className="modal-confirmacion-button"
                            onClick={() => onSubmit({ withLogout: false })}
                        />
                        {turnoActual?.nombre === "Nocturno" && checkNocturnoEnd(turnos?.turnos) && (
                            <Button
                                disabled={disableButtons}
                                text="Hacer corte y cerrar turno"
                                className="modal-confirmacion-button"
                                onClick={() => {
                                    onSubmit({ withLogout: true })
                                }}
                            />
                        )}
                        {turnoActual?.nombre !== "Nocturno" && (
                            <Button
                                disabled={disableButtons}
                                text="Hacer corte y cerrar turno"
                                className="modal-confirmacion-button"
                                onClick={() => {
                                    onSubmit({ withLogout: true })
                                }}
                            />
                        )}
                    </div>
                )}
            </Modal>
            <Modal
                isOpen={success}
                onClose={handleConfirm}
                width={600}
                withCloseButton
                className="modal-cortes-success"
            >
                <div>
                    <IconBorder
                        primaryBgColor="var(--green-card-available)"
                        primaryBgDiameter={32}
                        secondaryBgColor="var(--green-success-border)"
                        secondaryBgDiameter={48}
                        className="modal-cortes-success-icon"
                    >
                        <Icon name="checkFilled" color="var(--green-success)" height={24} width={24} />
                    </IconBorder>
                    <p className="modal-cortes-success-title">Corte de turno exitoso</p>
                    <span className="modal-cortes-success-folio">Folio: {successData?.folio}</span>
                    <div className="modal-cortes-success-info">
                        <Icon name="calendarSquare" height={16} width={16} />
                        <div className="modal-cortes-success-column" style={{ width: 180 }}>
                            <p className="modal-cortes-success-subtitle">Fecha de corte</p>
                            <p className="modal-cortes-success-value">
                                {formatCustomDate(UTCStringToLocalDate(successData?.fecha_inicio_corte), "DD/MMM/YY")}
                            </p>
                        </div>
                        <Icon name="calendarSquare" height={16} width={16} />
                        <div className="modal-cortes-success-column" style={{ width: 150 }}>
                            <p className="modal-cortes-success-subtitle">Turno</p>
                            <p className="modal-cortes-success-value">{turnoActual?.nombre}</p>
                        </div>
                        <Icon name="userFilled" height={16} width={16} />
                        <div className="modal-cortes-success-column" style={{ width: 150 }}>
                            <p className="modal-cortes-success-subtitle">Responsable</p>
                            <p className="modal-cortes-success-value">
                                {myProfile?.nombre} {myProfile?.apellido_paterno || ""}
                            </p>
                        </div>
                    </div>
                    <Button
                        text="Aceptar"
                        className="modal-confirmacion-button"
                        onClick={handleConfirm}
                        style={{ width: "100%" }}
                    />
                </div>
            </Modal>
            <LoaderComponent visible={isCerrarCorteLoading} />
        </>
    )
}

export default Confirmacion
